
import { http } from './api'

const resource = 'etapas-escolares'

export default {
    
    buscarEtapaEscolar:(dsserie) => {
        return http.get(`${resource}/buscar/${dsserie}`)
    },

    

    
}








